import { Select, MenuItem, FormControl, InputLabel, Grid, Checkbox, ListItemText, OutlinedInput } from '@mui/material'
import { PROJECT_TYPE, PROJECT_STATUS } from 'src/util/enums'
import MoreHorizIcon from '@mui/icons-material/MoreHoriz'
import { format, parse } from 'date-fns'
import idx from 'idx'
import _ from 'lodash'
import { useEffect, useState } from 'react'
import Popover from 'react-bootstrap/Popover'
import Tab from 'react-bootstrap/Tab'
import Tabs from 'react-bootstrap/Tabs'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { errorSnackBar, infoSnackBar, successSnackBar } from '../../../actions/common.action'
import { getCustomerList } from '../../../actions/customer-management.action'
import {
	deleteProject,
	duplicateProject,
	editProject,
	getProjectList,
	saveTemplate,
	bulkMaterialUpdate as bulkMaterialUpdateAction,
} from '../../../actions/project-management.action'

import DeleteDialog from '../../../components/delete-dialog'
import DuplicateProjectDialog from '../../../components/duplicate-project-dialog'
import Modal from '../../../components/modal/modal'
import CustomTable from '../../../components/table/table'
import { ADD_PROJECT, PROJECT_MANAGEMENT } from '../../../constants/route-paths'
import AddProject from '../add-project'
import AddTemplate from '../add-template-modal'
import ChangeProjectStatus from '../change-project-status'
import '../scss/project-management.scss'
import { getProjectType } from '../utils/getProjectStatus'
import { getProjectStatus } from './get-status'
import { getProjectTypeDisplayName } from './get-project-type-name'
import { projectListPasswordField } from './password-field'
import { verifyPassword } from 'src/actions/user-management.action'
import { ValidateField } from 'src/util/validators'
import CustomInput from 'src/components/inputs/new-input'
import { resolveProjectType } from '../utils/resolve-project-type'

export default function ProjectList({ writePermission, ...props }) {
	const entitlements = useSelector((state) => state.user.entitlements)
	const projectCategories = useSelector((state) => state.project.projectCategories)
	const reduxProjectState = useSelector((state) => state.project)
	const user = useSelector((state) => state.user.userData)
	let [searchParams] = useSearchParams()
	let [projectState, setProjectState] = useState({
		actions: null,
		anchorEl: null,
		projectId: null,
		projectsCount: {},
		...JSON.parse(JSON.stringify(projectListPasswordField)),
		type: entitlements.currentProject
			? PROJECT_TYPE.PROJECT
			: entitlements.quotesProject
				? PROJECT_TYPE.TENDER
				: PROJECT_STATUS.DLP,
		tableTitle: '',
		projects: [],
		project: [],
		tender: [],
		dlp: [],
		completed: [],
		lost: [],
		revision: [],
		archived: [],
		columns: {
			common: [
				{ title: 'Project No', field: 'tenderNumber', defaultSort: 'desc' },
				{
					title: 'Project Name',
					field: 'projectName',
					'data-cy': 'project-name',
					render: (row) => (
						<Link
							to={
								row.type == PROJECT_TYPE.TENDER
									? `/${PROJECT_MANAGEMENT}/edit/${row.id}`
									: `/${PROJECT_MANAGEMENT}/view/${row.id}`
							}>
							{row.projectName}
						</Link>
					),
				},
				{ title: 'Customer', field: 'customer' },
				{ title: 'Address', field: 'address' },
				{
					title: 'Project Type',
					field: 'quotetype',
					'data-cy': 'project-type',
					render: (row) => getProjectTypeDisplayName(row.quotetype),
				},
				{
					title: 'Project Status',
					field: 'status',
					'data-cy': 'project-status',
					render: (row) => getProjectStatus(row.status),
				},
				{ title: 'Project Created', field: 'createdAt' },
			],
			quotes: [
				{ title: 'Tender No.', field: 'tenderNumber', defaultSort: 'desc' },
				{
					title: 'Tender Name',
					field: 'projectName',
					'data-cy': 'project-name',
					render: (row) => (
						<Link to={`/${PROJECT_MANAGEMENT}/view/tender/${row.id}`}>
							{row.projectName}
						</Link>
					),
				},
				{ title: 'Customer', field: 'customer' },
				{ title: 'Address', field: 'address' },
				{
					title: 'Tender Type',
					field: 'quotetype',
					'data-cy': 'project-type',
					render: (row) => getProjectTypeDisplayName(row.quotetype),
				},
				{
					title: 'Tender Status',
					field: 'status',
					'data-cy': 'project-status',
					render: (row) => getProjectStatus(row.status),
				},
				{ title: 'Tender Created', field: 'createdAt' },
			],
			archived: [
				{ title: 'Project No', field: 'tenderNumber', defaultSort: 'desc' },
				{
					title: 'Project Name',
					field: 'projectName',
					'data-cy': 'project-name',
					render: (row) => (
						<Link
							to={
								row.type == PROJECT_TYPE.TENDER
									? `/${PROJECT_MANAGEMENT}/edit/${row.id}`
									: `/${PROJECT_MANAGEMENT}/view/${row.id}`
							}>
							{row.projectName}
						</Link>
					),
				},
				{
					title: 'Project Status',
					field: 'status',
					'data-cy': 'project-status',
					render: (row) => getProjectStatus(row.status),
				},
				{ title: 'Reason', field: 'reasonOfLost' },
			], //LOST,ARCHIVED,CANCELLED
			dlp: [
				{ title: 'Project No', field: 'tenderNumber', defaultSort: 'desc' },
				{
					title: 'Project Name',
					field: 'projectName',
					'data-cy': 'project-name',
					render: (row) => (
						<Link
							to={
								row.type == PROJECT_TYPE.TENDER
									? `/${PROJECT_MANAGEMENT}/edit/${row.id}`
									: `/${PROJECT_MANAGEMENT}/view/${row.id}`
							}>
							{row.projectName}
						</Link>
					),
				},
				{
					title: 'Project Status',
					field: 'status',
					'data-cy': 'project-status',
					render: (row) => getProjectStatus(row.status),
				},
				{ title: 'DLP Date', field: 'dateOfDLP' },
			],
		},
		projectType: null,
	})
	const [changeStatusDialog, setchangeStatusDialog] = useState(false)
	const [newStatus, setnewStatus] = useState('')
	const [deleteopen, setdeleteopen] = useState(false)
	const [confirmPasswordOpen, setConfirmPasswordOpen] = useState(false)
	const [deleteId, setdeleteId] = useState('')
	const [projectToDeleteId, setProjectToDeleteId] = useState('')
	const [viewProjectOpen, setviewProjectOpen] = useState(false)
	const [showTemplateModal, setshowTemplateModal] = useState('')
	const [customersList, setcustomersList] = useState([])
	const [showDuplicateDialog, setshowDuplicateDialog] = useState(false)
	const [tenderStatus, setTenderStatus] = useState(() => {
		const cached = sessionStorage.getItem('tenderStatus');
		return cached ? JSON.parse(cached) : [];
	})

	const dispatch = useDispatch()
	const navigate = useNavigate()

	useEffect(() => {
		const projectTypeParam = searchParams.get('project-type')
		if (!projectTypeParam && projectCategories && user) {
			const resolvedType = resolveProjectType(null, reduxProjectState);

			if (resolvedType) {
				navigate(
					`/${PROJECT_MANAGEMENT}?project-type=${resolvedType}`,
					{ replace: true }
				)
				return
			}
		}
		initLoad()
	}, [searchParams.get('project-type'), tenderStatus, projectCategories, user])

	const initLoad = async () => {
		if (searchParams.get('project-type')) await getProjetListHandler()
		await changeProjectType(
			searchParams.get('project-category')
				? searchParams.get('project-category')
				: projectState.type
		)
	}

	const getProjetListHandler = async () => {
		const projectList = []
		const tender = []
		const dlp = []
		const completed = []
		const archived = []

		try {
			let projects = await dispatch(
				getProjectList('', '', '', searchParams.get('project-type'), '', '', tenderStatus.length > 0 ? tenderStatus : null)
			)
				; (projects || []).forEach((project) => {
					let { isCurrent, isQuote, isDLP, isCompleted, isArchived } =
						getProjectType(project)
					if (isCurrent) {
						projectList.push(formatObj(project))
					} else if (isQuote) {
						tender.push(formatObj(project))
					} else if (isArchived) {
						archived.push(formatObj(project))
					} else if (isCompleted) {
						completed.push(formatObj(project))
					} else if (isDLP) {
						dlp.push(formatObj(project))
					}
				})
			setProjectState((prev) => ({
				...prev,
				projectsCount: {
					totalProjects: projectList.length,
					totalTenders: tender.length,
					totalDLP: dlp.length,
					totalArchived: archived.length,
					totalCompleted: completed.length,
					total:
						projectList.length +
						tender.length +
						dlp.length +
						completed.length +
						archived.length,
				},
				project: projectList,
				tender: tender,
				dlp,
				completed,
				archived,
				projectType: searchParams.get('project-type'),
			}))
		} catch (e) {
			console.error(e)
		}
	}

	const changeProjectType = async (type, rootProjectId) => {
		let actions = null
		if (Boolean(projectState.anchorEl)) {
			setProjectState((prev) => ({
				...prev,
				anchorEl: false,
				hasStages: null,
			}))
		}

		if (
			type === PROJECT_TYPE.PROJECT ||
			type === PROJECT_TYPE.TENDER ||
			type === PROJECT_STATUS.DLP ||
			type === PROJECT_STATUS.COMPLETED
		) {
			actions = [
				{
					icon: () => (
						<MoreHorizIcon
							aria-controls="simple-menu"
							aria-haspopup="true"
							style={{ color: '#d5d5d5' }}
						/>
					),
					tooltip: 'Edit',
					onClick: (event, rowData) => {
						handleMenu(
							event,
							rowData.id,
							rowData.hasStages,
							rowData.projectName
						)
					},
				},
			]
		}

		setProjectState((prev) => ({
			...prev,
			actions,
			type,
			tableTitle: !rootProjectId ? '' : projectState.tableTitle,
		}))
	}

	const handleMenu = (projectId, hasStages, projectName, rootProjectId) => {
		setProjectState((prev) => ({
			...prev,
			projectId,
			hasStages,
			projectName,
			rootProjectId: rootProjectId || null
		}))
	}

	const formatObj = (project) => {
		return {
			id: project.id,
			tenderNumber: project.tenderNumber,
			projectName: project.name,
			customer: project.customer && project.customer.business_name,
			address: project.address,
			quotetype: project.projectQuoteType,

			status: project.status,
			reasonOfLost: project.reasonOfLost,
			rootProjectId: project.rootProjectId,
			hasStages: project.hasStages,
			createdAt: format(new Date(project.dateOfCreation), 'dd/MM/yyyy'),
			dateOfDLP: project.dateOfDLP
				? format(new Date(project.dateOfDLP), 'dd/MM/yyyy')
				: '',
		}
	}

	const viewRevisions = (id = null) => {
		if (!id) id = projectState.projectId

		let { rootProjectId, projectName } =
			(projectState.tender || []).find((project) => project.id === id) || {}

		// Fallback to state if not found in current list (common during refresh)
		if (!rootProjectId) {
			rootProjectId = projectState.rootProjectId || id
			projectName = projectState.projectName
		}

		if (!rootProjectId) return


		handleClose()
		setProjectState((prev) => ({
			...prev,
			tableTitle: `Project - ${projectName}`,
			type: 'REVISION',
		}))
		dispatch(getProjectList(rootProjectId)).then((projects) => {
			const revision = []
			projects.forEach((project) => {
				if (project.type === 'TENDER' && project.status !== 'LOST') {
					revision.push({
						id: project.id,
						tenderNumber: project.tenderNumber,
						projectName: project.name,
						customer: project.customer && project.customer.business_name,
						address: project.address,
						status: project.status,
						rootProjectId: project.rootProjectId,
						createdAt: format(new Date(project.dateOfCreation), 'dd/MM/yyyy'),
						quotetype: project.projectQuoteType,
					})
				}
			})
			setProjectState((prev) => ({
				...prev,
				revision,
			}))
		})
	}

	const handleClose = () => {
		setProjectState((prev) => ({
			...prev,
			anchorEl: null,
			hasStages: null,
		}))
	}

	const addProject = () => {
		if (
			entitlements.totalProjects <= (projectState.projectsCount.total || 0) &&
			entitlements.totalProjects >= 0
		) {
			dispatch(
				errorSnackBar(
					'You have reached the limit of creating projects. Please contact our Support Team'
				)
			)
			return
		}
		navigate(
			`/${PROJECT_MANAGEMENT}/${ADD_PROJECT}?project-type=${projectState.projectType}`
		)
	}

	const _editProject = (id) => {
		if (!id) return
		navigate(`/${PROJECT_MANAGEMENT}/edit/${id}`)
	}

	const assetDialogHandler = (id) => {
		if (!id) return
		navigate(`/projects/asset/${id}`)
	}

	const markAsInProgress = (id) => {
		handleClose()
		dispatch(editProject({ status: 'IN_PROGRESS' }, id)).then((res) => {
			getProjetListHandler()
		})
	}

	const markAsCompleted = (id) => {
		handleClose()
		dispatch(editProject({ status: 'COMPLETED' }, id)).then((res) => {
			getProjetListHandler()
		})
	}

	const changeStatusHandler = () => {
		if (changeStatusDialog) {
			getProjetListHandler()
		}
		setchangeStatusDialog(!changeStatusDialog)
	}

	const markAsDLP = () => {
		setnewStatus('DLP')
		handleClose()
		changeStatusHandler()
	}

	const changeStatus = (data) => {
		dispatch(editProject(data, projectState.projectId)).then((res) => {
			changeStatusHandler()
			getProjetListHandler()
		})
	}

	const markAsArchived = () => {
		handleClose()
		setnewStatus('ARCHIVED')
		changeStatusHandler()
	}

	const deleteDialogHandler = (id = '') => {
		handleClose()
		setdeleteopen(!deleteopen)
		setdeleteId(id)
		setProjectState((prev) => ({
			...prev, password: { ...prev.password, value: "" }
		}))
	}

	const deleteHandler = (id = '') => {
		markAsDeleted()
		setProjectToDeleteId(id)
		deleteDialogHandler(id)
	}

	const deleteDescription = () => {
		const { project, tender, dlp, completed, archived, revision } = projectState
		const projectList = [...project, ...tender, ...dlp, ...completed, ...archived, ...revision]
		const projectToDelete = projectList.find((_) => _.id == deleteId)
		const projectName = idx(projectToDelete, (_) => _.projectName) || ''
		return `Project - ${projectName}`
	}

	const inputPasswordChaneHandler = (e) => {
		let password = projectState.password
		// var name
		var value
		if (_.isObject(e)) {
			// name = e.target.name
			value = e.target.value
		}

		password.value = value
		password.touched = true
		const { error, valid } = ValidateField({ value, validation: password.validation })
		password.error = error
		password.valid = valid
		setProjectState({ ...projectState, password })
	}

	const verifyUserPassword = () =>
		dispatch(verifyPassword(projectState.password.value)).then((res) => {
			return true
		}).catch(err => {
			throw new Error(err)
		})

	const handlePasswordVerification = async () => {
		handleClose()
		const { password } = projectState
		let isPasswordFieldValid = true
		const { error, valid } = ValidateField({ value: password.value, validation: password.validation })
		password.touched = true
		password.valid = valid
		password.error = error
		isPasswordFieldValid = isPasswordFieldValid && valid

		if (!isPasswordFieldValid) {
			setProjectState({ ...projectState, password })
		} else {
			try {
				const result = await verifyUserPassword()
				if (result && projectToDeleteId) {
					dispatch(deleteProject(projectToDeleteId, projectState.type)).then((res) => {
						if (projectState.type == 'REVISION') {
							viewRevisions(projectState.rootProjectId || projectState.projectId)
						}
						getProjetListHandler()
					})

					setConfirmPasswordOpen(false)
				}

			} catch (error) {
				setProjectState({ ...projectState, password })
			}
		}
	}

	const markAsDeleted = () => {
		handleClose()
		setConfirmPasswordOpen(true)
	}

	const handleViewProjectClose = () => {
		const dialogState = viewProjectOpen
		setviewProjectOpen(!dialogState)
		if (dialogState) {
			handleClose()
			getProjetListHandler()
		}
	}

	const templateModalHandler = (status) => {
		setshowTemplateModal(status)
	}

	const _saveTemplate = (data) => {
		templateModalHandler(false)
		let hasStages = projectState.hasStages
		let projectId = projectState.projectId
		dispatch(saveTemplate({ ...data, projectId, hasStages }))
			.then((res) => { })
			.catch((err) => templateModalHandler(true))
		handleClose()
	}

	const reviseProject = (id = null) => {
		if (!id) return
		navigate(`/${PROJECT_MANAGEMENT}/edit/${id}?action=revise`)
	}

	const _duplicateProject = async (customerId = null, data = {}) => {
		const projectId = data?.id || projectState.projectId
		// const projectName = data?.projectName

		handleClose()
		if (customerId) {
			await dispatch(duplicateProject({ projectId, customerId })).then(
				(res) => {
					getProjetListHandler()
				}
			)
		}
		if (!showDuplicateDialog) {
			let customersList = await dispatch(getCustomerList('business_name,first_name,name'))

			customersList =
				(Array.isArray(customersList) &&
					customersList.map((customer) => {
						return {
							key: customer.businessName,
							value: customer.id,
						}
					})) ||
				[]

			setcustomersList(customersList)
		}
		setshowDuplicateDialog(!showDuplicateDialog)
	}

	const markAsSubmit = (id) => {
		handleClose()
		dispatch(editProject({ status: PROJECT_STATUS.TENDER_SUBMITTED }, id)).then((res) => {
			getProjetListHandler()
		})
	}

	const updatePricing = (id) => {
		handleClose()
		dispatch(bulkMaterialUpdateAction({
			projectIds: [id],
			updateFromCatalog: true,
			createRevision: true
		})).then(res => {
			// Check if revisions were created
			if (res?.revisions && res.revisions.length > 0) {
				dispatch(successSnackBar('New project revision created with updated pricing.'));
			} else {
				// Check for warnings if no revision was created
				const noChangeWarning = (res?.warnings || []).find(w => w.type === 'NO_CHANGES');
				if (noChangeWarning) {
					dispatch(infoSnackBar(`No pricing changes detected for ${noChangeWarning.name || 'this project'}. Revision creation skipped.`));
				} else {
					dispatch(successSnackBar('Pricing updated successfully.'));
				}
			}

			// Refresh the project list
			getProjetListHandler()
		})

	}

	return (
		<>
			{changeStatusDialog && (
				<ChangeProjectStatus
					open={changeStatusDialog}
					dialogClose={changeStatusHandler}
					changeStatus={changeStatus}
					projectId={projectState.projectId}
					newStatus={newStatus}
				/>
			)}
			{deleteopen && (
				<DeleteDialog
					open={deleteopen}
					id={deleteId}
					deleteHandler={deleteHandler}
					dialogClose={deleteDialogHandler}
					moduleName="Project"
					description={deleteDescription()}
				/>
			)}
			<Modal open={confirmPasswordOpen} onClose={() => {
				setConfirmPasswordOpen(false);
				setProjectState({ ...projectState, projectListPasswordField })
			}}
				onClick={handlePasswordVerification}
				showActionBtn
				modalHeading={'Enter Password To Confirm Deletion'}
				modalSaveTxt='Confirm'
				modalCloseTxt='Cancel'
				fullWidth={true}
				maxWidth={'md'}
			>
				<CustomInput {...projectState.password} onChange={(e) => inputPasswordChaneHandler(e)} />
			</Modal>
			{viewProjectOpen && (
				<Modal
					open={viewProjectOpen}
					onClose={handleViewProjectClose}
					modalHeading={'Convert To Project'}
					modalSaveTxt="Convert"
					modalCloseTxt="Cancel"
					fullWidth={true}
					maxWidth={'md'}
					modalContent={
						<AddProject
							{...props}
							currentStep={0}
							tenderEditPage={true}
							projectId={projectState.projectId}
							convertTender={true}
							convertToProject={true}
							handleClose={handleViewProjectClose}
						/>
					}
					primary
				/>
			)}
			{showTemplateModal && (
				<AddTemplate
					templateModalHandler={templateModalHandler}
					open={showTemplateModal}
					saveTemplate={_saveTemplate}
				/>
			)}
			{showDuplicateDialog && (
				<DuplicateProjectDialog
					open={showDuplicateDialog}
					dialogClose={_duplicateProject}
					customersList={customersList}
				/>
			)}

			<div className="purchase-order-block">
				<div className="row">
					<div className="w-auto">
						<h2 className="content-heading text-uppercase">Projects</h2>
					</div>
					<div className="w-auto ms-auto mt-auto">
						{writePermission && (
							<button
								onClick={addProject}
								className="secondarybtn secondarybtn-outline btn-ch ms-auto btn btn-primary">
								Create Project
							</button>
						)}
					</div>
				</div>

				<div className="row">
					<div className="col-12">
						<Tabs
							defaultActiveKey={projectState.type.toLowerCase()}
							activeKey={projectState.type.toLowerCase()}
							id="uncontrolled-tab-example"
							className="mb-3"
							onSelect={(k) => {
								switch (k) {
									case 'project':
										changeProjectType(PROJECT_TYPE.PROJECT)
										break
									case 'revision':
									case 'tender':
										changeProjectType(PROJECT_TYPE.TENDER)
										break
									case 'dlp':
										changeProjectType(PROJECT_STATUS.DLP)
										break
									case 'completed':
										changeProjectType(PROJECT_STATUS.COMPLETED)
										break
									case 'archived':
										changeProjectType(PROJECT_STATUS.ARCHIVED)
										break
									default:
										break
								}
							}}>
							{entitlements.currentProject && (
								<Tab
									eventKey="project"
									title={`Current Projects (${projectState.projectsCount.totalProjects})`}
									tabClassName="current-projects-tab"
								>
									<CustomTable
										columns={projectState.columns.common}
										data={_.orderBy(
											projectState.project,
											['tenderNumber'],
											['desc']
										)}
										isAction={true}
										handleMenu={(data) =>
											handleMenu(data.id, data.hasStages, data.projectName)
										}
										dataCy="current-projects-table"
										menu={(data) => (
											<Popover id="popover-basic" data-cy="project-action-dropdown">
												<Popover.Body>
													<ul className="action-block-list">
														<li onClick={() => _editProject(data.id)} data-cy="edit-project">Edit</li>
														<li onClick={() => assetDialogHandler(data.id)}>
															Assets
														</li>
														{writePermission && (
															<>
																<li onClick={() => markAsInProgress(data.id)} data-cy="mark-as-in-progress">
																	Mark as In Progress
																</li>
																<li onClick={() => markAsDLP()} data-cy="mark-as-dlp">Mark as DLP</li>
																<li onClick={() => markAsCompleted(data.id)} data-cy="mark-as-completed">
																	Mark as Completed
																</li>
																<li onClick={() => markAsArchived()} data-cy="archive">
																	Archive
																</li>
																<li
																	onClick={() => deleteDialogHandler(data.id)}>
																	Delete
																</li>
															</>
														)}
													</ul>
												</Popover.Body>
											</Popover>
										)}
										fileName="Current Project List"
									/>
								</Tab>
							)}
							{entitlements.quotesProject &&
								projectState.type != 'REVISION' && (
									<Tab
										eventKey="tender"
										title={`Quotes (${projectState.projectsCount.totalTenders})`}
										tabClassName="quotes-tab"
									>
										<CustomTable
											columns={projectState.columns.quotes}
											data={_.orderBy(
												projectState[projectState.type.toLowerCase()].filter(row => tenderStatus.length === 0 || tenderStatus.includes(row.status)),
												[(row) => parse(row.createdAt, 'dd/MM/yyyy', new Date())],
												['desc']
											)}

											isAction={true}
											handleMenu={(data) =>
												handleMenu(data.id, data.hasStages, data.projectName, data.rootProjectId)
											}
											dataCy="quotes-table"
											toolbarActions={[
												<FormControl variant="outlined" size="small" style={{ minWidth: 200 }}>
													<InputLabel id="tender-status-filter-label">Filter by Status</InputLabel>
													<Select
														labelId="tender-status-filter-label"
														id="tender-status-filter"
														multiple
														value={tenderStatus}
														onChange={(e) => {
															const value = e.target.value;
															setTenderStatus(value);
															sessionStorage.setItem('tenderStatus', JSON.stringify(value));
														}}
														input={<OutlinedInput label="Filter by Status" />}
														renderValue={(selected) => {
															if (selected.length === 0) return <em>All Statuses</em>;
															const statusLabels = {
																[PROJECT_STATUS.COSTED]: 'Costed',
																[PROJECT_STATUS.TENDER_SUBMITTED]: 'Submitted',
																[PROJECT_STATUS.PENDING]: 'Pending',
																[PROJECT_STATUS.LOI]: 'LOI',
																[PROJECT_STATUS.IN_PROGRESS]: 'In Progress'
															};
															return selected.map(s => {
																const count = projectState.tender.filter(row => row.status === s).length;
																const label = statusLabels[s] || s;
																return `${label} (${count})`;
															}).join(', ');
														}}
														MenuProps={{
															PaperProps: {
																style: {
																	maxHeight: 224,
																	width: 250,
																},
															},
														}}
													>
														<MenuItem value={PROJECT_STATUS.COSTED}>
															<Checkbox checked={tenderStatus.indexOf(PROJECT_STATUS.COSTED) > -1} />
															<ListItemText primary={'Costed'} />
														</MenuItem>
														<MenuItem value={PROJECT_STATUS.TENDER_SUBMITTED}>
															<Checkbox checked={tenderStatus.indexOf(PROJECT_STATUS.TENDER_SUBMITTED) > -1} />
															<ListItemText primary={'Submitted'} />
														</MenuItem>
														<MenuItem value={PROJECT_STATUS.PENDING}>
															<Checkbox checked={tenderStatus.indexOf(PROJECT_STATUS.PENDING) > -1} />
															<ListItemText primary={'Pending'} />
														</MenuItem>
														<MenuItem value={PROJECT_STATUS.LOI}>
															<Checkbox checked={tenderStatus.indexOf(PROJECT_STATUS.LOI) > -1} />
															<ListItemText primary={'LOI'} />
														</MenuItem>
														<MenuItem value={PROJECT_STATUS.IN_PROGRESS}>
															<Checkbox checked={tenderStatus.indexOf(PROJECT_STATUS.IN_PROGRESS) > -1} />
															<ListItemText primary={'In Progress'} />
														</MenuItem>
													</Select>
												</FormControl>
											]}
											menu={(data) => (
												<Popover id="popover-basic" data-cy="project-action-dropdown">
													<Popover.Body>
														<ul className="action-block-list">
															<li onClick={() => viewRevisions(data.id)} data-cy="view-revisions">
																View Revisions
															</li>
															{writePermission && (
																<>
																	<li className={entitlements.currentProject ? '' : 'disabled'}
																		onClick={() => {
																			if (entitlements.currentProject)
																				handleViewProjectClose(data.id)
																		}}>
																		Convert to Project
																	</li>
																	<li onClick={() => templateModalHandler(true)} data-cy="create-as-template">
																		Create as Template
																	</li>
																	<li onClick={() => reviseProject(data.id)} data-cy="new-revision">
																		New Revision
																	</li>
																	{data.status === PROJECT_STATUS.COSTED && (
																		<li onClick={() => updatePricing(data.id)} data-cy="update-pricing">
																			Update Pricing
																		</li>
																	)}
																	<li onClick={() => _duplicateProject(null, data)} data-cy="duplicate-project">
																		Duplicate Project
																	</li>
																	<li onClick={() => markAsSubmit(data.id)} data-cy="mark-as-submit">
																		Mark as Submit
																	</li>
																	<li onClick={() => markAsArchived()} data-cy="archive">
																		Archive
																	</li>
																	<li onClick={() => deleteDialogHandler(data.id)} data-cy="delete">
																		Delete
																	</li>
																</>
															)}
														</ul>
													</Popover.Body>
												</Popover>
											)}
											fileName="Quotes List"
										/>
									</Tab>
								)}
							{projectState.type == 'REVISION' && (
								<Tab
									eventKey="revision"
									title={`Quotes Rev (${(projectState[projectState.type.toLowerCase()] || []).length})`}
									tabClassName="quotes-rev-tab"
								>
									<CustomTable
										columns={projectState.columns.quotes}
										data={_.orderBy(
											projectState[projectState.type.toLowerCase()],
											[
												(item) => {
													const qMatch = String(item.tenderNumber || '').match(/Q(\d+)/i);
													return qMatch ? parseInt(qMatch[1], 10) : 0;
												},
												(item) => {
													const revMatch = String(item.tenderNumber || '').match(/Rev\.\((\d+)\)/i);
													return revMatch ? parseInt(revMatch[1], 10) : 0;
												}
											],
											['desc', 'desc']
										)}
										isAction={true}
										handleMenu={(data) =>
											handleMenu(data.id, data.hasStages, data.projectName, data.rootProjectId)
										}
										dataCy="quotes-rev-table"
										menu={(data) => (
											<Popover id="popover-basic" data-cy="project-action-dropdown">
												<Popover.Body>
													<ul className="action-block-list">
														<li onClick={() => viewRevisions(data.id)} data-cy="view-revisions">
															View Revisions
														</li>
														{writePermission && (
															<>
																<li
																	className={
																		entitlements.currentProject
																			? ''
																			: 'disabled'
																	}
																	onClick={() => {
																		if (entitlements.currentProject)
																			handleViewProjectClose(data.id)
																	}}>
																	Convert to Project
																</li>
																<li onClick={() => templateModalHandler(true)} data-cy="create-as-template">
																	Create as Template
																</li>
																<li onClick={() => reviseProject(data.id)} data-cy="new-revision">
																	New Revision
																</li>
																{data.status === PROJECT_STATUS.COSTED && (
																	<li onClick={() => updatePricing(data.id)} data-cy="update-pricing">
																		Update Pricing
																	</li>
																)}
																<li
																	onClick={() => _duplicateProject(null, data)} data-cy="duplicate-project">
																	Duplicate Project
																</li>
																<li onClick={() => markAsSubmit(data.id)} data-cy="mark-as-submit">
																	Mark as Submit
																</li>
																<li onClick={() => markAsArchived()} data-cy="archive">
																	Archive
																</li>
																<li
																	onClick={() => deleteDialogHandler(data.id)} data-cy="delete">
																	Delete
																</li>
															</>
														)}
													</ul>
												</Popover.Body>
											</Popover>
										)}
										fileName="Quotes Rev List"
									/>
								</Tab>
							)}
							{entitlements.currentProject && (
								<Tab
									eventKey="dlp"
									title={`DLP Projects (${projectState.projectsCount.totalDLP})`}
									tabClassName="dlp-tab"
								>
									<CustomTable
										columns={projectState.columns.dlp}
										data={_.orderBy(
											projectState.dlp,
											['tenderNumber'],
											['desc']
										)}
										isAction={true}
										handleMenu={(data) =>
											handleMenu(data.id, data.hasStages, data.projectName, data.rootProjectId)
										}
										dataCy="dlp-table"
										menu={(data) => (
											<Popover id="popover-basic" data-cy="project-action-dropdown">
												<Popover.Body>
													<ul className="action-block-list">
														{writePermission && (
															<>
																<li
																	className={
																		entitlements.currentProject
																			? ''
																			: 'disabled'
																	}
																	onClick={() => {
																		if (entitlements.currentProject)
																			handleViewProjectClose(data.id)
																	}}>
																	Mark as Current
																</li>
																<li onClick={() => markAsCompleted(data.id)} data-cy="mark-as-completed">
																	Mark as Completed
																</li>
																<li onClick={() => markAsArchived()} data-cy="archive">
																	Mark as Archived
																</li>
															</>
														)}
													</ul>
												</Popover.Body>
											</Popover>
										)}
										fileName="DLP Project List"
									/>
								</Tab>
							)}
							{entitlements.currentProject && (
								<Tab
									eventKey="completed"
									title={`Completed (${projectState.projectsCount.totalCompleted})`}
									tabClassName="completed-tab"
								>
									<CustomTable
										columns={projectState.columns.common}
										data={_.orderBy(
											projectState.completed,
											['tenderNumber'],
											['desc']
										)}
										isAction={true}
										handleMenu={(data) =>
											handleMenu(data.id, data.hasStages, data.projectName, data.rootProjectId)
										}
										dataCy="completed-table"
										menu={(data) => (
											<Popover id="popover-basic" data-cy="project-action-dropdown">
												<Popover.Body>
													<ul className="action-block-list">
														{writePermission && (
															<>
																<li
																	className={
																		entitlements.currentProject
																			? ''
																			: 'disabled'
																	}
																	onClick={() => {
																		if (entitlements.currentProject)
																			handleViewProjectClose(data.id)
																	}}>
																	Mark as Current
																</li>
																<li onClick={() => markAsArchived()} data-cy="archive">
																	Mark as Archived
																</li>
																<li onClick={() => markAsDLP()} data-cy="mark-as-dlp">Mark as DLP</li>
															</>
														)}
													</ul>
												</Popover.Body>
											</Popover>
										)}
										fileName="Completed Project List"
									/>
								</Tab>
							)}
							{writePermission && (
								<Tab
									eventKey="archived"
									title={`Archived (${projectState.projectsCount.totalArchived})`}
									tabClassName="archived-tab"
								>
									<CustomTable
										columns={projectState.columns.archived}
										data={_.orderBy(
											projectState.archived,
											['tenderNumber'],
											['desc']
										)}
										dataCy="archived-table"
										fileName="Archived Project List"
									/>
								</Tab>
							)}
						</Tabs>
					</div>
				</div>
			</div >
		</>
	)
}
